export const OUTFITS = 'OUTFITS';
export const OUTFIT = 'OUTFIT';
export const DELETE = 'DELETE';
export const SORT = 'SORT';
export const MORE = 'MORE';
export const LOADING = 'LOADING';
export const TOTAL = 'TOTAL';

export default {
  OUTFITS,
  OUTFIT,
  DELETE,
  SORT,
  MORE,
  LOADING,
  TOTAL,
};
